import * as React from "react";
import Svg, { Path } from "react-native-svg";

const LearnIcon = (props) => (
  <Svg
    width={48}
    height={48}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M20.714 30.372c0-3.226-6.37-3.67-6.37-11.772 0-8.1 4.5-8.905 4.5-12.05 0-3.145-12.464.68-12.464 12.742 0 12.062 14.334 14.306 14.334 11.08Z"
      stroke={props.color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M30.304 27.217c-3.226 0-3.671 6.37-11.772 6.37s-8.905-4.5-12.05-4.5c-3.145 0 .68 12.465 12.742 12.465 12.062 0 14.306-14.335 11.08-14.335v0Zm-12.608-6.399c3.226 0 3.671-6.37 11.772-6.37s8.905 4.5 12.05 4.5c3.145 0-.68-12.465-12.742-12.465-12.062 0-14.306 14.335-11.08 14.335Z"
      stroke={props.color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M27.286 17.628c0 3.226 6.371 3.671 6.371 11.772s-4.5 8.905-4.5 12.05c0 3.145 12.464-.68 12.464-12.742 0-12.062-14.335-14.306-14.335-11.08Z"
      stroke={props.color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
LearnIcon.defaultProps = {
  color: "#fff",
};
export default LearnIcon;
